import React from 'react';
import './ThemeToggle.css';
import { MoonStar, SunMedium } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button className="theme-toggle" onClick={toggleTheme} aria-label="Cambia tema">
      {isDark ? <SunMedium size={18} /> : <MoonStar size={18} />}
    </button>
  );
}